import generator from "generate-password-browser"

const userModel = {
  id: "",
  displayName: "",
  accessToken: "",
  email: "",
  metadata: {
    createdAt: "",
    lastLoginAt: "",
    lastSignInTime: "",
    creationTime: "",
  },
  phoneNumber: null,
  constructUser: function (user) {
    this.id = user?.uid
    this.displayName = user?.displayName
    this.accessToken = user?.accessToken
    this.email = user?.email
    this.emailVerified = user?.emailVerified
    this.metadata = user?.metadata
    this.phoneNumber = user?.phoneNumber
  },
}

const userProfileModel = {
  id: "",
  authID: "",
  profile: {
    email: "",
    displayName: "",
    createdAt: Date.now(),
  },
  emailApproved: false,
  welcomeEmailNotSent: true,
  admin: false,
  plan: null,
  relatedUsers: [],
  hosts: [],
  purchases: 0,
  purchasesHistory: [],
  freeUsers: 2,
  licenceKey: null,
  constructProfile: function (data, user) {
    this.id = data?.id
    this.authID = user?.id
    this.emailApproved = data?.emailApproved || false
    this.welcomeEmailNotSent = true
    this.admin = data?.admin || false
    this.plan = data?.plan
    this.profile = {
      email: user?.email,
      displayName: user?.displayName,
      createdAt: user?.metadata?.createdAt || data?.profile.createdAt,
    }
    this.relatedUsers = data?.relatedUsers || []
    this.hosts = data?.hosts || []
    this.purchases = data?.purchases
    this.purchasesHistory = data?.purchasesHistory
    this.freeUsers = data?.freeUsers
    this.licenceKey = data?.licenceKey
      ? data?.licenceKey
      : generator.generate({
          length: 5,
          numbers: true,
        })
  },
  generateLicenceKey: function () {
    const key = generator.generate({
      length: 5,
      numbers: true,
    })

    this.licenceKey = key
  },
}

const feedbackModel = {
  id: "",
  pageSlug: "",
  feedbacks: [],
  constructFeedback: function (feedback) {
    this.id = feedback?.id
    this.pageSlug = feedback?.pageSlug
    this.feedbacks = feedback?.feedbacks || []
  },
}

const commentsModel = {
  id: "",
  pageSlug: "",
  comments: [],
  constructComment: function (comment) {
    this.id = comment?.id
    this.pageSlug = comment?.pageSlug
    this.comments = comment?.comments || []
  },
}

export { userModel, userProfileModel, feedbackModel, commentsModel }
